<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useDisplay } from 'vuetify'
import { loaded } from '~/composables/useAccessEventHandler'

const { mdAndDown, smAndDown } = useDisplay()
const offerVisitStore = useOfferVisitsStore()
const { offerVisit: clientContext } = storeToRefs(offerVisitStore)

function navigateHome() {
  window.travelClient.navigateTo({ view: 'home' })
}
</script>

<template>
  <v-app-bar
    v-if="loaded"
    class="app-bar"
    :density="smAndDown ? 'compact' : 'comfortable'"
    scroll-behavior="fully-hide"
    scroll-threshold="1"
    height="80"
    :elevation="1"
  >
    <v-app-bar-title :class="mdAndDown ? 'app-bar--small' : 'app-bar--large'">
      <div
        class="app-bar-content"
        :class="{ 'app-bar--mobile': smAndDown }"
      >
        <span v-if="clientContext?.clientLogoUrl">
          <v-img
            :class="smAndDown ? 'logo-size-small' : 'logo-size-large'"
            :src="clientContext.clientLogoUrl"
          />
        </span>
        <span
          class="text-ellipsis"
          :class="[smAndDown ? 'font-size-small' : '']"
        >
          Traveler Cashback
        </span>
        <v-spacer />
        <div
          class="font-size-small font-weight-regular"
          :class="smAndDown ? 'app-bar--small' : 'app-bar--large'"
        >
          <v-btn
            v-if="smAndDown"
            icon="mdi-home-outline"
            variant="text"
            @click="navigateHome"
          />
          <v-btn
            v-else
            prepend-icon="mdi-home-outline"
            variant="text"
            @click="navigateHome"
          >
            Go Home
          </v-btn>
        </div>
      </div>
    </v-app-bar-title>
  </v-app-bar>
</template>

<style lang="scss" scoped>
.padding-small {
  padding: 0;
}

.padding-large {
  padding: 0 30px;
  max-width: 1500px;
  margin: auto !important;
}

.flex-center {
  display: flex;
  align-items: center;
  gap: 30px;
}

.logo-size-large {
  width: 6rem;
}

.logo-size-small {
  width: 5rem;
}

.text-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font-normal {
  font-weight: 500;
  line-height: 1.2em;
  white-space: normal;
}

.font-size-small {
  font-size: 0.85em;
}

.app-bar-content {
  @extend .flex-center;
  @extend .font-normal;
}

.app-bar--small {
  @extend .padding-small;
}

.app-bar--large {
  @extend .padding-large;
}

.app-bar--mobile {
  gap: 10px;
}
</style>
